import React, { Component } from "react";
import FlexView from "react-flexview";
import Button from "../../../../modules/commons/Button";
import { ACTIVITY_TYPE } from "../../../common/Constants";
import {
  DELETE_STATUS,
  FOLLOWUP_STATUS,
  TABS
} from "./constants";

export const tabelConfig = ({
  status,
  handleDetailVisibility,
  handleFollowUpVisible,
}) => {
  return [
    {
      name: "id",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const { page, rowsPerPage } = tableMeta.tableState;
          const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

          return <React.Fragment>{rowNumber}</React.Fragment>;
        },
      },
    },
    {
      name: "kodeCabang",
      label: "Kode Cabang",
      options: {
        sort: false,
      },
    },
    {
      name: "overdue",
      label: "Overdue",
      options: {
        sort: false,
        display: [TABS.NON_FOLLOW_UP, TABS.ONGOING].includes(status),
      },
    },
    {
      name: "tanggalProspek",
      label: "Tanggal Prospek",
      options: {
        sort: false,
      },
    },
    {
      name: "noProspek",
      label: "Nomor Prospek",
      options: {
        sort: false,
      },
    },
    {
      name: "nama",
      label: "Nama",
      options: {
        sort: false,
      },
    },
    {
      name: "nik",
      label: "NIK",
      options: {
        sort: false,
      },
    },
    {
      name: "nomorHp",
      label: "No. HP",
      options: {
        sort: false,
      },
    },
    {
      name: "alamat",
      label: "Alamat",
      options: {
        sort: false,
      },
    },
    {
      name: "provinsi",
      label: "Provinsi",
      options: {
        sort: false,
      },
    },
    {
      name: "kabkot",
      label: "Kota/Kabupaten",
      options: {
        sort: false,
      },
    },
    {
      name: "kecamatan",
      label: "Kecamatan",
      options: {
        sort: false,
      },
    },
    {
      name: "kelurahan",
      label: "Kelurahan",
      options: {
        sort: false,
      },
    },
    {
      name: "cabangAsal",
      label: "Cabang Asal",
      options: {
        sort: false,
      },
    },
    {
      name: "penjualTerakhir",
      label: "Penjual Terakhir",
      options: {
        sort: false,
      },
    },
    {
      name: "pemilikProspek",
      label: "Pemilik Prospek",
      options: {
        sort: false,
      },
    },
    {
      name: "kategoriProspek",
      label: "Kategori Prospek",
      options: {
        sort: false,
      },
    },
    {
      name: "jenisProspek",
      label: "Jenis Prospek",
      options: {
        sort: false,
      },
    },
    {
      name: "asalProspek",
      label: "Asal Prospek",
      options: {
        sort: false,
      },
    },
    {
      name: "lastFollowUpDate",
      label: "Last Follow Up Date",
      options: {
        sort: false,
        display: status !== TABS.NON_FOLLOW_UP,
      },
    },
    {
      name: "lastFollowUpStatus",
      label: "Last Follow Up Status",
      options: {
        sort: false,
        display: status !== TABS.NON_FOLLOW_UP,
      },
    },
    {
      name: "lastFollowUpBy",
      label: "Last Follow Up By",
      options: {
        sort: false,
        display: status !== TABS.NON_FOLLOW_UP,
      },
    },
    {
      name: "nextAppointmentDate",
      label: "Next Appointment Date",
      options: {
        sort: false,
        display: status !== TABS.NON_FOLLOW_UP,
      },
    },
    {
      name: "keterangan",
      label: "Keterangan",
      options: {
        sort: false,
      },
    },
    {
      name: "noProspek",
      label: "Aksi",
      options: {
        customBodyRender: (val) => {
          return (
            <FlexView
              style={{ justifyContent: "space-evenly", width: "100px" }}
            >
              <ButtonAction
                iconName="fa-eye"
                onClick={() => handleDetailVisibility(val, ACTIVITY_TYPE.VIEW)}
              />
              {FOLLOWUP_STATUS.includes(status) && (
                <ButtonAction
                  iconName="fa-person-booth"
                  onClick={() => handleFollowUpVisible(val)}
                />
              )}
              {DELETE_STATUS.includes(status) && (
                <ButtonAction
                  iconName="fa-trash"
                  onClick={() =>
                    handleDetailVisibility(val, ACTIVITY_TYPE.DELETE)
                  }
                />
              )}
            </FlexView>
          );
        },
      },
    },
  ];
};

class ButtonAction extends Component {
  render() {
    const { iconName, onClick, ...rest } = this.props;
    return (
      <Button
        {...rest}
        className="btnAct background-transparent txt-site txt-title"
        type="button"
        onClick={onClick}
      >
        <i className={`fa ${iconName} color-red`} />
      </Button>
    );
  }
}
